import axios from '@/utils/axios';

// 印花兑换记录
export function getExchangeLogList(page, limit) {
    return axios({
        url: '/stamp/exchange-log/list',
        method: 'get',
        params: { page, limit },
    });
}

// 会员印花更新记录
export function stampUpdateLog(page, limit) {
    return axios({
        url: '/stamp/list',
        method: 'get',
        params: { page, limit },
    });
}

// 获取活动列表
export function getActivityList() {
    return axios({
        url: '/stamp/activity/list',
        method: 'get',
        params: { },
    });
}

// 活动报名
export function activityReport( activityId, username, realname, province, city, area, address, mobile ) {
    return axios({
        url: '/stamp/activity/join',
        method: 'post',
        params: { activityId, username, realname, province, city, area, address, mobile },
    });
}


export function getStampMaxNum() {
    return axios({
        url: '/stamp/max/num',
        method: 'get',
        params: { },
    });
}

export function checkStamp( code ) {
    return axios({
        url: '/stamp/check',
        method: 'post',
        params: { code },
    });
}
